// Сброс сессии при простое. Считаем человека и загрузки, а не запросы: автоматические опросы
// сюда не попадают сами, поэтому новые экраны и запросы ничего не требуют.
//
// В localStorage одна запись на все вкладки, поэтому загрузка в одной вкладке держит остальные,
// а закончившаяся сессия видна и странице входа. Запись живёт от входа до ручного выхода.
const STORAGE_KEY = 'pdla';
const WRITE_METHODS = ['post', 'put', 'patch', 'delete'];
// Опрос столько не длится, значит это скачивание
const LONG_REQUEST_MS = 30000;

type SessionActivity = {
  at: number
  minutes: number
};

type TrackedRequest = {
  write: boolean
  startedAt: number
};

const activeRequests = new Set<TrackedRequest>();
let holds = 0;
let timeoutMinutes = 0;

function readActivity(): SessionActivity | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) as SessionActivity : null;
  } catch {
    return null;
  }
}

function writeActivity(value: SessionActivity): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // без записи сессия просто не будет сбрасываться
  }
}

function isExpired({ at, minutes }: SessionActivity): boolean {
  return minutes > 0 && Date.now() - at >= minutes * 60000;
}

/** Сколько минут простоя закончили сессию, 0 — время не вышло */
export function getIdleLogoutMinutes(): number {
  const activity = readActivity();
  return activity && isExpired(activity) ? activity.minutes : 0;
}

/** Таймаут приходит с каждым токеном, поэтому новое значение доходит до открытых вкладок */
export function rememberIdleTimeout(minutes = 0): void {
  timeoutMinutes = minutes;
  const activity = readActivity();
  if (activity) writeActivity({ ...activity, minutes });
}

export function startSessionActivity(): void {
  writeActivity({ at: Date.now(), minutes: timeoutMinutes });
}

/** Вышедшее время не продлевается: первое движение мышью после сна компьютера сессию не спасёт */
export function touchSessionActivity(): void {
  const activity = readActivity();
  if (activity && !isExpired(activity)) writeActivity({ ...activity, at: Date.now() });
}

export function clearSessionActivity(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // нечего чистить
  }
}

/** Идёт загрузка: запись на сервер, долгий запрос или отметка `holdSession` */
export function isSessionBusy(): boolean {
  const now = Date.now();
  return holds > 0 || Array.from(activeRequests).some(
    ({ write, startedAt }) => write || now - startedAt >= LONG_REQUEST_MS,
  );
}

/** Для ожидания без запросов, когда человек просто смотрит на экран. Возвращает снятие отметки */
export function holdSession(): () => void {
  holds += 1;
  return () => {
    holds -= 1;
  };
}

/** Запись считается сразу и в конце: между кусками загрузки время не должно идти */
export async function trackRequest<T>(
  method: string | undefined,
  send: () => Promise<T>,
): Promise<T> {
  const request = {
    write: WRITE_METHODS.includes(method || ''),
    startedAt: Date.now(),
  };
  activeRequests.add(request);
  if (request.write) touchSessionActivity();
  try {
    return await send();
  } finally {
    activeRequests.delete(request);
    if (request.write) touchSessionActivity();
  }
}
